import {Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export interface InternalInterface {
	sharePointOnlineBridge?: any;
}

export class Internal implements InternalInterface, Parameter {
	public sharePointOnlineBridge?: any;

	constructor(data: any) {
		this.sharePointOnlineBridge = data.sharePointOnlineBridge;
	}

	public static getSharePointOnlineBridgeDefault(): any {
		return {};
	}

	public static fromJson(data: any): Internal {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new Internal(data);
	}

	public toJson(): any {
		return {
			'sharePointOnlineBridge': this.sharePointOnlineBridge,
		};
	}

	public clone(): Internal {
		return Internal.fromJson(this.toJson());
	}
}
